<template>
    <v-select v-model="selectedStatus" :items="optionStatuses" :disabled="disabled" item-value="id" :clear-icon="'far fa-times-circle'" :menu-props="{ bottom: true, offsetY: true }" @change="$emit('input', selectedStatus)" :multiple="multiple" :label="label" background-color="white" hide-details outlined clearable dense>
        <template v-slot:selection="data">
            <v-chip :color="data.item.color" label small dark close @click:close="selectedStatus.splice(data.index, 1)">
                {{ data.item.label }}
            </v-chip>
        </template>
        <template v-slot:item="{ item }">
            <v-list-item-content>
                <v-list-item-title>
                    <v-chip :color="item.color" label small dark>
                        {{ item.label }}
                    </v-chip>
                </v-list-item-title>
            </v-list-item-content>
        </template>
    </v-select>
</template>

<script>
import optionsMixin from '../../mixins/options.js';

export default {
    name: 'OptionStatusSelect',

    mixins: [optionsMixin],

    props: {
        value: { required: true },
        label: { type: String, default: 'Etat' },
        disabled: { type: Boolean, default: false },
        multiple: { type: Boolean, default: false }
    },

    data: () => ({
        selectedStatus: null
    }),

    created() {
        this.selectedStatus = this.value;
    }
};
</script>